module.exports = __webpack_public_path__ + "static/notification-0082312f2f155af45d940efa2e7edbda.mp4";